// dependencies
import { List, Map, isImmutable } from "immutable";
import { useState } from "react";

/** Manages the state of an employee list on the <ReviewFormCard />
 * component. Will keep track of the list of employees as well as the
 * employee picker value.
 */
const useEmployeeList = (defaultEmployees = List()) => {
	const [employees, setEmployees] = useState(defaultEmployees);
	const [employeePickerValue, setEmployeePicker] = useState("");
	const [employeeIDs, setEmployeeIDs] = useState({});

	/**
	 * Remove an employee by index.
	 * @param {string} index - index of the employee we are removing
	 */
	const removeEmployee = (employeeID) => {
		setEmployees(employees.filter((item) => item.get("id") !== employeeID));
	};

	/**
	 * Handle changing the employee picker value. Will add the employee to the
	 * list if a Map or will update the input value if a string.
	 * prevents duplicate authors
	 */
	const handleEmployeesChange = (value) => {
		if (isImmutable(value)) {
			const employeeID = value.get("id");
			const employeeName = value.get("name");
			if (employeeIDs[employeeID] !== 1) {
				setEmployees(employees.push(Map({ id: employeeID, name: employeeName })));
				setEmployeePicker("");
				setEmployeeIDs({ ...employeeIDs, [employeeID]: 1 });
			}
		} else {
			setEmployeePicker(value);
		}
	};

	/**
	 * Set employee list.
	 */
	const setEmployeeList = (employeesList) => {
		setEmployees(employeesList);
	};

	/**
	 * Resets the hook state.
	 */
	const resetState = () => {
		setEmployeePicker(null);
		setEmployees(defaultEmployees);
	};

	return [employees, employeePickerValue, handleEmployeesChange, removeEmployee, setEmployeeList, resetState];
};

export default useEmployeeList;
